import React, { useMemo } from 'react'
import ContextMenu from 'tyan/public/components/Form/Block/base/ContextMenu'

const PlanContextMenu = props => {
	const { schedule, contextMenu, onGetData } = props

	const target = useMemo(() => `#${schedule && schedule.id || 'schedule'}`, [schedule])

	const handleGetData = selectedTarget => {
		const data = schedule.getEventDetails(selectedTarget)
		return onGetData ? onGetData(data) : data
	}

	return schedule && <ContextMenu target={target} filter='e-appointment' contextMenu={contextMenu} onGetData={handleGetData} /> || null
}

export default PlanContextMenu